import { ErrorObject } from '@vuelidate/core';

export type InputErrorObject = Pick<ErrorObject, '$uid' | '$message'>;

export type RangeTitles = {
  min: string;
  max: string;
};

export type DateTimeTitles = {
  date: string;
  time: string;
};

export enum TextInputMode {
  TEXT = 'text',
  PASSWORD = 'password',
}

export enum TextInputMask {
  PHONE = 'phone',
  INN = 'inn',
  OGRN = 'ogrn',
  OGRNIP = 'ogrnip',
  SNILS = 'snils',
  CREDIT_CARD = 'credit-card',
  ACT = 'act',
}

export enum SelectInputMode {
  DEFAULT = 'default',
  FILTER = 'filter',
}

export enum BtnSelectInputMode {
  ROUND = 'round',
  SQUARE = 'square',
}

export type DateRangeInputValue = {
  start: string;
  end: string;
};

export type AutocompleteOption<T> = {
  readonly value: T;
  readonly title: string;
  readonly alias?: string;
};

export function isRangeTitles(value: unknown): value is RangeTitles {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  const titles = value as Record<string, unknown>;

  return typeof titles.max === 'string' && typeof titles.min === 'string';
}

export function isDateTimeTitles(value: unknown): value is DateTimeTitles {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  const titles = value as Record<string, unknown>;

  return typeof titles.date === 'string' && typeof titles.time === 'string';
}

export enum SocialMediaType {
  WHATSAPP = 'whatsapp',
  TELEGRAM = 'telegram',
  VK = 'vk',
  INSTAGRAM = 'instagram',
  OK = 'ok',
  OTHER = 'other',
}

export type SocialNetworkOption = {
  guid: string;
  code: string;
  title: string;
  domains?: SocialNetworkDomain[];
};

export type SocialNetworkDomain = {
  domain: string;
  isPrimary: boolean;
};

export function isDateRangeValue(value: unknown): value is DateRangeInputValue {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  const dates = value as Record<string, unknown>;

  return typeof dates.start === 'string' && typeof dates.end === 'string';
}
